/**
 * WordPress-safe jQuery wrapper
 *
 * Structure overview:
 * 
 * (function($) {        	// 1 > Creates a private scope & aliases jQuery as $
 *   	$(function() {   	// 2 > Waits until the DOM is fully loaded
 *     		// 3 > Your code runs safely here
 *      });
 * })(jQuery);            	// 4 > Passes the global jQuery object into the IIFE
 *
 * Why this pattern is used:
 * --------------------------------------------------------------
 * - WordPress loads jQuery in *noConflict* mode, so `$` is not
 *   available globally by default. Passing `jQuery` as `$` here
 *   gives you a shorthand safely within this scope.
 *
 * - The outer (function($){ ... })(jQuery) is an IIFE (Immediately
 *   Invoked Function Expression), which:
 *     • Creates a private namespace — prevents your variables,
 *       functions, and constants from leaking into the global scope.
 *     • Avoids collisions with other scripts or plugins.
 *
 * - The inner $(function(){ ... }) is shorthand for
 *   $(document).ready(function(){ ... }); — it ensures your code
 *   only runs *after* the entire DOM has been parsed and is ready
 *   to manipulate.
 *
 * - This combined pattern is the professional, WordPress-standard
 *   way to write jQuery code in themes and plugins. It ensures
 *   your scripts are:
 *     • Safe
 *     • Isolated
 *     • Cross-plugin compatible
 *     • DOM-ready
 *
 * TL;DR:
 * - Safe `$` alias ✅
 * - Private scope ✅
 * - DOM-ready execution ✅
 * - Compatible with WordPress core ✅
 */

(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {

		// === Define the plugin ===
		$.fn.smartNav = function (options) {
			const settings = $.extend(
				{
					breakpoint: 1024,
					activeClass: 'active',
					submenuSelector: 'ul',
					caretSelector: 'span',
				},
				options
			);

			const $menu = this;
			let isMobile = false;
			let currentEvent = null;

			const isMobileDevice = () =>
				/Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);

			const checkDeviceMode = () => {
				const width = $(window).width();
				isMobile = width < settings.breakpoint || isMobileDevice();
			};

			const resetNav = () => {
				$menu.find('li').removeClass(settings.activeClass);
				$menu.find(settings.caretSelector).off();
				$menu.find('a').off();
				$menu.find('li').off('mouseenter mouseleave');
				$(document).off(currentEvent + '.smartNav'); // remove document handler namespaced
				currentEvent = null;
			};

			const initDesktop = () => {
				$menu.find('li').each(function() {
					const $li = $(this);
					if ($li.children(settings.submenuSelector).length) {
						$li.on('mouseenter.smartNav', function() {
							$li.addClass(settings.activeClass);
						});
						$li.on('mouseleave.smartNav', function() {
							$li.removeClass(settings.activeClass);
						});
					}
				});
			};

			const initMobile = () => {
				const possibleEvents = ['touchstart', 'click'];
				let chosenEvent = null;

				for (const evt of possibleEvents) {
					if ('on' + evt in window) {
						chosenEvent = evt;
						break;
					}
				}

				currentEvent = chosenEvent || 'click';

				$menu.find('li').each(function() {
					const $li = $(this);
					const $submenu = $li.children(settings.submenuSelector);
					const $caret = $li.children(settings.caretSelector);

					if ($submenu.length && $caret.length) {
						$caret.on(currentEvent + '.smartNav', function(e) {
							e.preventDefault();
							e.stopPropagation();

							const isActive = $li.hasClass(settings.activeClass);

							// - Close only sibling items at the same level (and any active 
							//   descendants of them)
							// - Keep ancestor <li> items (the parents) active
							const $sameLevelSiblings = $li.closest('ul').children('li').not($li);

							$sameLevelSiblings
								.removeClass(settings.activeClass)
								.find('li')
								.removeClass(settings.activeClass);

							// Toggle current item
							if (isActive) {
								$li
									.removeClass(settings.activeClass)
									.find('li')
									.removeClass(settings.activeClass);
							} else {
								$li.addClass(settings.activeClass);
							}
						});
					}
				});

				// Close ALL when tapping outside the entire menu
				$(document).on(currentEvent + '.smartNav', function(e) {
					if (!$(e.target).closest($menu).length) {
						$menu.find('li').removeClass(settings.activeClass);
					}
				});
			};

			const init = () => {
				resetNav();
				checkDeviceMode();
				if (isMobile) {
					initMobile();
				} else {
					initDesktop();
				}
			};

			init();

			$(window).on('resize.smartNav', function() {
				const prevMode = isMobile;
				checkDeviceMode();
				if (prevMode !== isMobile) {
					init();
				}
			});

			return this;
		};

	    // === Invoke the plugin ===
	    $('.wrap--sh__menu-container').smartNav({
	      	breakpoint: 1024,
	      	activeClass: 'active',
	    });		

	    $('.wrap--cta--mobile-nav a').on('click', function(e) {

	    	e.preventDefault();

	    	$('html').addClass('mobile-overlay--active');

	    	setTimeout( function() {

				$('.sh__main-nav__mobile').css({
					opacity: 1,
					visibility: 'visible',
				});

	    	}, 150)

	    })

	    $('.wrap--mnm__close a').on('click', function(e) {

	    	e.preventDefault();

			$('.sh__main-nav__mobile').css({
				opacity: 0,
				visibility: 'hidden',
			});

	    	setTimeout( function() {

		    	$('html').removeClass('mobile-overlay--active');

	    	}, 150)

	    })	    

  	});

})(jQuery);
